module.exports = __webpack_public_path__ + "static/media/Sharp-LS021B7DD02-Mechanical-Drawing.d06550fd.jpg";